import PropTypes from 'prop-types'

const props = {
  title: PropTypes.string,
  message: PropTypes.string,
  onDismiss: PropTypes.func,
}

export default function Notification ({title}){
  // TODO: Add onDismiss Handler
  return (
    <div className="tw-px-4 tw-py-2 tw-bg-black/75 tw-text-white tw-rounded-2xl">
      {title}
    </div>
  )
}
Notification.propTypes = props
